import { render, staticRenderFns } from "./RefillFintechRecommendation.vue?vue&type=template&id=70be5bb4&scoped=true&"
import script from "./RefillFintechRecommendation.vue?vue&type=script&lang=js&"
export * from "./RefillFintechRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./RefillFintechRecommendation.vue?vue&type=style&index=0&id=70be5bb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70be5bb4",
  null
  
)

export default component.exports